export enum ActionTypes {
    SHOW_NOTIFICATIONS = 'notifications-module/show-notifications',
    PUSH_NOTIFICATION = 'notifications-module/push-notification',
}
